import React, { useState, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import Ruleta from './Ruleta.';
import { mostrarAviso, mostrarExito, mostrarInfo } from '../../utils/Alertas';
import { Typography, TextField } from '@mui/material';
import './css/GanadorAleatorio.css';

const GanadorAleatorio: React.FC = () => {
    const [jugadores, setJugadores] = useState<string[]>([]);
    const [inputValue, setInputValue] = useState<string>('');
    const [girando, setGirando] = useState<boolean>(false);
    const [startAngle, setStartAngle] = useState(0);
    const [haGirado, setHaGirado] = useState(false);
    const [ganadorMostrado, setGanadorMostrado] = useState(false);
    const intervalRef = useRef<NodeJS.Timeout | null>(null);


    // Función para agregar jugadores a la lista
    const handleAddPlayer = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' && inputValue.trim()) {
            e.preventDefault();

            if (girando) {
                mostrarInfo("No se pueden añadir jugadores mientras gira la ruleta.");
                return;
            };

            if (jugadores.includes(inputValue.trim())) {
                mostrarAviso(`El participante "${inputValue.trim()}" ya ha sido añadido.`);
                return;
            }

            setJugadores([...jugadores, inputValue.trim()]);
            setInputValue('');
        }
    };

    // Función para resetear la lista de jugadores
    const resetJugadores = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }

        setInputValue('');
        setJugadores([]);
        setGirando(false);
        setStartAngle(0);
        setGanadorMostrado(false);
        setHaGirado(false);
    };


    // Función que comienza a "girar" la ruleta con frenado progresivo
    const iniciarRuleta = () => {
        if (jugadores.length > 0) {  // No iniciamos la ruleta si la alerta de participante duplicado está activa
            setGirando(true);
            setHaGirado(true);
            setGanadorMostrado(false);

            let spinTime = 0;
            let currentSpeed = 50; // Velocidad inicial alta
            const fastSpinDuration = 3000; // 3 segundos de giro rápido
            const spinTimeTotal = Math.random() * 3 + 6 * 1000; // Duración total del giro (6-9 segundos)

            intervalRef.current = setInterval(() => {
                const spinAngle = currentSpeed;
                setStartAngle(prevAngle => prevAngle + (spinAngle * Math.PI) / 180);

                spinTime += 30;

                if (spinTime >= fastSpinDuration) {
                    currentSpeed *= 0.965;
                }

                if (currentSpeed <= 0.5 || spinTime >= spinTimeTotal) {
                    if (intervalRef.current) {
                        clearInterval(intervalRef.current);
                        intervalRef.current = null;
                    }
                    setGirando(false);
                }
            }, 30);
        }
    };

    return (
        <div className="container-fluid">
            <div className="text-center">
                <h2>Ganador aleatorio</h2>
            </div>

            <div className="container-fluid content py-3">
                <form className="row ganador-form-row">
                    <div className="form-group mb-3">
                        <TextField
                            label="Nombre del participante"
                            id="jugadores"
                            name="jugadores"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            onKeyDown={handleAddPlayer}
                            fullWidth
                            style={{ marginTop: 0 }}
                        />

                        <Typography variant="caption" color="text.secondary">
                            Presiona intro para añadir un nuevo participante.
                        </Typography>
                    </div>
                </form>

                <div className="row ganador-form-row">
                    <div className="col-6">
                        <button className="reset-button" type="button" onClick={(e) => { e.preventDefault(); resetJugadores(); }}>Reset</button>
                    </div>
                    <div className="col-6">
                        <button className="main-button" type="button" onClick={(e) => { e.preventDefault(); iniciarRuleta(); }} disabled={girando || jugadores.length === 0}>
                            {girando ? 'Girando...' : 'Iniciar Ruleta'}
                        </button>
                    </div>
                </div>

                {/* Mostrar la ruleta directamente debajo del formulario */}
                {jugadores.length > 0 && (
                    <div className="ruleta-wrapper" style={{ marginTop: '20px' }}>
                        <Ruleta
                            options={jugadores}
                            startAngle={startAngle}
                            isSpinning={girando}
                            haGirado={haGirado}
                            onSpinEnd={(ganador: string) => {
                                if (girando || ganadorMostrado || jugadores.length === 0) return;

                                mostrarExito(`¡El ganador es: ${ganador}!`);
                                setGanadorMostrado(true);
                            }}

                        />
                    </div>
                )}

            </div>
        </div>
    );
};

export default GanadorAleatorio;
